module.exports = __webpack_public_path__ + "static/dteams-c19a6f2dab15e9b0a981999ec4566bfe.mp4";